import { MdClose } from "react-icons/md";
import React from "react";
import { twMerge } from "tailwind-merge";
import { DialogTitle, IconButton } from "@material-ui/core";

type TitleProps = {
  className?: string;
  children: React.ReactNode;
  onClose?: () => void;
};

export const Title = ({
  className,
  children,
  onClose,
}: TitleProps): React.ReactElement => (
  <DialogTitle className={twMerge("m-0 bg-white", className)}>
    <div className="flex items-center justify-between">
      {children}

      {onClose ? (
        <IconButton
          component="span"
          aria-label="close"
          className=" text-gray-500"
          onClick={onClose}
        >
          <MdClose className="text-base font-medium" />
        </IconButton>
      ) : null}
    </div>
  </DialogTitle>
);
